import createIcon from '../../createIcon';

/**
 * @component @name CardMembership
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuODkgMiAyIDIuODkgMiA0VjE1QzIgMTYuMTEgMi44OSAxNyA0IDE3SDhWMjJMMTIgMjBMMTYgMjJWMTdIMjBDMjEuMTEgMTcgMjIgMTYuMTEgMjIgMTVWNEMyMiAyLjg5IDIxLjExIDIgMjAgMlpNMjAgMTVINFYxM0gyMFYxNVpNMjAgMTBINFY0SDIwVjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CardMembership = createIcon('CardMembership', [
  [
    'path',
    {
      d: 'M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z',
      key: '1s3b8a',
    },
  ],
]);

export default CardMembership;
